'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { PrivacyBand as SitePrivacyBand } from '@/components/site/privacy-band'

export function HomePrivacyBand() {
  const { t } = useTranslation(['web'])
  return (
    <SitePrivacyBand
      eyebrow={t('web:homePage.privacy.eyebrow')}
      titleKey="web:homePage.privacy.title"
      lead={t('web:homePage.privacy.lead')}
      items={[
        {
          title: t('web:homePage.privacy.trainingTitle'),
          description: t('web:homePage.privacy.trainingDesc'),
        },
        {
          title: t('web:homePage.privacy.retentionTitle'),
          description: t('web:homePage.privacy.retentionDesc'),
        },
        {
          title: t('web:homePage.privacy.uploadTitle'),
          description: t('web:homePage.privacy.uploadDesc'),
        },
      ]}
    />
  )
}
